<template>
  <v-container fluid>
    <v-layout pb-4 wrap>
      <FilterByClient />
      <FilterByName />
      <FilterByEmail />
      <Search />
    </v-layout>
    <v-layout wrap>
      <v-flex xs12>
        <UsersList :users="usersList" />
      </v-flex>
      <v-flex v-if="totalPages && totalPages > 1" xs12 text-xs-center pt-4>
        <v-pagination
          v-model="currentPage"
          :length="totalPages"
          :disabled="busy"
        ></v-pagination>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import UsersList from '../components/Users/UsersList.vue';
import FilterByClient from '../components/Users/Filters/FilterByClient.vue';
import FilterByEmail from '../components/Users/Filters/FilterByEmail.vue';
import FilterByName from '../components/Users/Filters/FilterByName.vue';
import Search from '../components/Users/Search.vue';

export default {
  name: 'users',
  components: {
    UsersList,
    FilterByClient,
    FilterByEmail,
    FilterByName,
    Search,
  },
  data: () => ({
    page: 1,
    busy: false,
  }),
  computed: {
    ...mapGetters('users', [
      'usersList',
      'totalPages',
      'query',
    ]),
    currentPage: {
      get() {
        return parseInt(this.$route.params.page, 0);
      },
      set(page) {
        this.setCurrentPage(page);
        this.$router.push({ path: `/uzytkownicy/${page}`, query: this.query });
      },
    },
  },
  methods: {
    ...mapActions('users', [
      'getUsersList',
      'setQuery',
      'setCurrentPage',
    ]),
    getList() {
      const { query, params } = this.$route;
      const page = parseInt(params.page, 0);
      this.setQuery(query);
      this.setCurrentPage(page);
      this.getUsersList(params.page);
    },
  },
  beforeDestroy() {
    this.setQuery(null);
  },
  mounted() {
    this.getList();
  },
  watch: {
    $route() {
      this.getList();
    },
  },
};
</script>
